module.exports = __webpack_public_path__ + "75e4812af1ef07b15b80ff84902b9400.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/kite-s.png
// module id = 1303
// module chunks = 0